module.exports = __webpack_public_path__ + "2cabef25e9144dae84731720e52924cf.MP3";